import Platform from '@/plugin-platforms'

export const state = () => ({
  message: null,
  duration: 5000,
  type: 'info',
  show: false,
  timer: null
})

export const mutations = {
  showMessage (state, { message, duration, type }) {
    state.show = true
    state.message = message
    state.type = type
    state.duration = duration
  },
  clearMessage (state) {
    state.show = false
  }
}

export const actions = {
  showMessage ({ commit }, { message, type = 'primary', duration = 5000 }) {
    if (Platform.features.messages) {
      Platform.showMessage({ message, duration, type })
    } else {
      commit('showMessage', { message, duration, type })
    }
  }
}
